<template>
  <div class="product-card__product-select">
    <CustomSelect
      :active-value="selectActiveValue"
      label-name="name"
      :select-list="productOption.variants"
      :class="{ 'checked' : selectedValue }"
      @emitOptions="setCurrentValue"
    />
  </div>
</template>

<script setup lang="ts">
import type { IProductOption, IProductOptionsVariant } from '#sitis/internal/controllers/products/models/ProductOptions';
import CustomSelect from '~/components/UI/CustomSelect.vue';

const { productOption } = defineProps<{
	productOption:IProductOption,
}>();

const emit = defineEmits<{
	updateOptions:[opt:IProductOptionsVariant&{productOptionId:number}],
}>();
const selectedValue = ref<IProductOptionsVariant | undefined>();
const { $priceFormat } = useNuxtApp();
const setCurrentValue = (prop: IProductOptionsVariant) => {
  selectedValue.value = prop;
  emit('updateOptions', { ...prop, productOptionId: productOption.id });
};

const selectActiveValue = computed(() => (selectedValue.value
  ? `${selectedValue.value?.name} <span> + ${$priceFormat({ amount: selectedValue.value?.price, decimalCount: 0 })} ₽</span>`
  : `Укажите параметр: ${productOption.name}`));
</script>

<style lang="scss">
.product-card__product-select{
  .select.open{
    & .select-element{
      border-radius: 4px 4px 0 0;
    }
  }

  & .checked{
    & .select-element{
      border-color: var(--secondary);
    }
  }

  .select-element{
    height: 50px;
    display: flex;
    align-items: center;
    border-color: var(--primary);
    border-radius: 4px;
    color: var(--text-black);
    font-size: 18px;
    line-height: 23px;
    font-weight: 500;

    & > img{
      top: 50%;
    }

    @media screen and (max-width: 340px) {
      font-size: 16px;
    }
  }

  .select-dropdown{
    border-radius: 0 0 4px 4px;
    top: calc(100% + -1px);
  }
}
</style>
